export const text = {
  title: "Список пользователей",
  addUserTitle: "Добавление аккаунта",
  FIO: "ФИО",
  phone: "Телефон",
  email: "Email",
  type: "Тип аккаунта",
  status: "Статус",
};
